// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2G7Ki8EILfJT5kE8pFmqsf"};